"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BanksList = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./BanksList.css"));
var _uiKit = require("@cian/ui-kit");
var _newbuildingUtils = require("@cian/newbuilding-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BanksList = props => {
  const {
    banks
  } = props;
  const title = React.useMemo(() => {
    return `Выдаётся в ${(0, _newbuildingUtils.pluralize)(banks.length, ['банке', 'банках', 'банках'])}`;
  }, [banks]);
  if (banks.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style['container']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, title), banks.map((bank, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: style['bank']
  }, /*#__PURE__*/React.createElement(_uiKit.Avatar, {
    type: "bank",
    src: bank.logoUrl,
    size: 40,
    hideBorder: true
  }), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, bank.name))));
};
exports.BanksList = BanksList;